module.exports = __webpack_public_path__ + "img/logo.5c618958.png";